import { Box, Typography, Button, } from "@mui/material";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom"; 

export default function PetLostConfirmation() {
    const { t } = useTranslation();
    const isMobile = window.innerWidth <= 768;
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const foundreport = searchParams.get('type'); // 'lost' or 'found'

    return (
        <Box
            sx={{ background: "#FCF8F3", minHeight: "100vh", pt: { xs: 6, md: 10 } }}
        >
            <Navbar />
            <Box
                sx={{
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    alignItems: "center",
                    justifyContent: "center",
                    pt: isMobile ? 10 : 30,
                }}
            >
                <Box sx={{
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 2,
                    width: isMobile ? "80%" : "70%",
                    }}>
                    <img src="\icons\check-circle.png" alt="" width={isMobile ? 50 : 'auto'}/>
                    <Typography
                        variant="h5"
                        fontWeight={700}
                        sx={{
                            mb: 1,
                            fontSize: { xs: 16, sm: 24, md: 28 },
                            textAlign: { xs: "left", md: "left" },
                        }}
                    >
                        {foundreport === "found" ? t("FoundReport") : t("PetLostConfirmation")}
                    </Typography>
                </Box>
            </Box>
            <Box
                sx={{
                    maxWidth: 1080,
                    width: "100%",
                    mx: "auto",
                    px: { xs: 1, sm: 2 },
                    pt: { xs: 1, md: 3 },
                    pb: { xs: 4, md: 8 },
                }}
            >
                <Box sx={{ display: "flex", width: "100%", justifyContent: "center", pt: isMobile ? 0 : 4 }}>
                    <Button
                        variant="contained"
                        sx={{
                            background: "#FFB60C",
                            color: "#050505",
                            fontWeight: 700,
                            fontSize: 16,
                            borderRadius: 2,
                            px: 6,
                            py: 1.5,
                            my: 2,
                            boxShadow: "none",
                            width: { xs: "100%", md: "auto" },
                            "&:hover": { background: "#FFB60C" },
                        }}
                        fullWidth={true}
                        onClick={() => { window.location.href = "/"; }}
                    >
                        {t('BackToHome')}
                    </Button>
                </Box>
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 2,
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    color: '#65A8FB',
                    mt: 2,
                }} onClick={() => { navigate("/all_lost_pets");
                    }}>
                    <Typography
                    >
                        {t("ViewallLostPets")}
                    </Typography>
                </Box>
            </Box>
            <Footer />
        </Box>
    );
}
